import { detect } from 'detect-browser';

const browser = detect();

export const isSafari = browser.name === 'safari';

export const isiOS = browser.os === 'iOS';

export const shouldRunSampleAudio = isSafari || isiOS;

export const browserAllowsDownload = !isiOS;
